import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemMailSendRoute: InvariantJiraRoute = {
	name: 'global-settings-system-mail-send',
	path: '/secure/admin/SendBulkMail!default.jspa',
};
